// eslint-disable-next-line import/prefer-default-export
const basicTask = {
  id: '',
  dueDateDate: new Date(),
  dueDateTime: new Date(),
  description: ''
};

export default basicTask;
